'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { Alert } from '@repo/ui/components/alert';
import { PageView } from '@repo/ui/components/page-view';

import { ERROR_LABELS } from '~/definitions/labels';
import { HOME_PAGE_ROUTE } from '~/definitions/routes';

const FIVE_SECONDS_IN_MS = 5000;

function NotFoundPage() {
  const { push } = useRouter();

  useEffect(() => {
    const timeoutId = setTimeout(() => push(HOME_PAGE_ROUTE), FIVE_SECONDS_IN_MS);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <PageView>
      <Alert
        title={ERROR_LABELS.PAGE_NOT_FOUND}
        message={ERROR_LABELS.PAGE_NOT_FOUND_MESSAGE}
        severity="error"
      />
    </PageView>
  );
}

export default NotFoundPage;
